import EntityTitle from '@/entity/components/EntityTitle'
import Vue from 'vue'
import httpManager from '../../util/common'

let vm= {
    components:{EntityTitle},
    data:()=>{
        return{
            oaid:null,
            report_id:null,
            researcher_name:null,
            subject_words:null,
            innovation_rate:null,
            data:{},
            content:null,
        }
    },
    methods:{
        getDetailData(){
            let self=this
            let params = new Map()
            params.set('report_id',self.report_id)
            httpManager('stock_report_detail',params,null,null,null)
            .then((response)=>{
                self.data=response.data.data[0]
                self.content=self.data.abstract.replace(/\\r\\n/g, '<br/>')
            })
            .catch((error)=>{
                console.log('error');
            })
        }
    },
    mounted(){
        this.oaid=this.$route.params.oaid
        this.report_id=this.$route.query.report_id
        this.researcher_name=this.$route.query.researcher_name
        this.subject_words=this.$route.query.subject_words
        this.innovation_rate=this.$route.query.innovation_rate
        this.getDetailData()
    },
    computed:{
        detail_list(){
            let list=this.data
            return [list.publish_date,list.institution,this.researcher_name,'关键词: '+this.subject_words,'创新性分数: '+this.innovation_rate]
        }
    }
}

Vue.component("report-details", vm)
export default vm


// WEBPACK FOOTER //
// ./src/research_report/js/report_details.js